import { render } from "./GroupsChecklistItensListComponent.vue?vue&type=template&id=1cb5b237&ts=true"
import script from "./GroupsChecklistItensListComponent.vue?vue&type=script&lang=ts"
export * from "./GroupsChecklistItensListComponent.vue?vue&type=script&lang=ts"

import "./GroupsChecklistItensListComponent.vue?vue&type=style&index=0&id=1cb5b237&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__